import React from "react";
import { useSearchParams } from "next/navigation";

import MetaTags from "@/components/MetaTags";

import useFilters from "../../hooks/useFilters";

type Props = {
  description?: string;
  title?: string;
};

const StrainListHead: React.FunctionComponent<Props> = ({
  description,
  title,
}: Props) => {
  const searchParams = useSearchParams();
  const pageName = searchParams?.get("pageName") || "";
  const sort = searchParams?.get("sort");
  const page = searchParams?.get("page") || 1;

  const { filtersApplied } = useFilters();

  const metaDescription =
    description ||
    "Browse the most comprehensive marijuana strain database on the web! Read strain reviews, discover new strains, and learn more about your favorites.";
  const metaTitle = title || `${pageName} marijuana strains | Leafly`;

  return (
    <MetaTags
      description={`${metaDescription}${
        Number(page) > 1 ? ` Page ${page}.` : ""
      }`}
      title={`${metaTitle}${Number(page) > 1 ? ` | page ${page}` : ""}`}
      canonicalParams={["page"]}
      image="https://public.leafly.com/web-strain-explorer/explore-og-image.png"
      robots={filtersApplied || sort ? "noindex" : undefined}
    />
  );
};

export default StrainListHead;
